module.exports = __webpack_public_path__ + "static/media/service1.648772c9.jpeg";